<template>
  <div class="new-crumbs">
    <span class="direct-tip">当前位置：</span>
    <template v-for="(item, index) in trails">
      <template v-if="item.href">
        <span :key="index">
          <span v-if="index"> > </span>
          <router-link
            class="direct-dir"
            :to="{ name: item.href, params: {id: item.id }}"
          >{{item.trail}}</router-link>
        </span>
      </template>
      <template v-else>
        <span :key="index">
          <span v-if="index"> > </span>
          <span class="direct-sub-dir">{{ item.trail }}</span>
        </span>

      </template>
    </template>

  </div>
</template>

<script>
export default {
  props: {
    trails: Array
  }
};
</script>

<style lang="scss">
@import "../../../common/scss/color.scss";

.new-crumbs {
  padding-left: 6px;
  border-left: 3px solid #bbb;
  margin: 14px 10px;
  background-color: #f5f5f5;
  height: 37px;
  line-height: 37px;
  font-size: 14px;
  .direct-tip {
    color: #333;
  }
  .direct-dir {
    color: $mainColor;
    &:hover {
      text-decoration: underline;
    }
  }
  .direct-sub-dir {
    color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/public/crumbs/newCrumbs.vue